import { Icons } from '@commenda/kakashi';
import {
  formatNumberWithCommas,
  formatNumberWithCommasAndDecimals,
} from '../../../sales-tax/utils';

interface AccruingAmountCardProps {
  amount: number;
  jurisdiction: string;
  numberOfTransactions: number;
  taxableSales: number;
  nonTaxableSales: number;
  marketplaceSales: number;
  exemptSales: number;
  grossSales: number;
  onViewTransactions?: () => void;
}

export const AccruingAmountCard = ({
  amount,
  jurisdiction,
  numberOfTransactions,
  taxableSales,
  nonTaxableSales,
  onViewTransactions,
  marketplaceSales,
  exemptSales,
  grossSales,
}: AccruingAmountCardProps) => {
  return (
    <div className="rounded-2xl border border-border-primary bg-white flex flex-col gap-lg">
      <div className="flex flex-col gap-md p-3xl">
        <div className="flex items-center gap-xs">
          <span className="text-text-quaternary txt-small-medium">Tax due</span>
        </div>

        <div className="flex items-center gap-md">
          <div className="flex items-center gap-sm">
            <span className="text-text-quaternary display-sm-regular">$</span>
            <span className="text-text-primary display-md-bold">
              {formatNumberWithCommasAndDecimals(amount)}
            </span>
          </div>
          <div
            onClick={onViewTransactions}
            className="flex items-center gap-sm text-utility-blue-600 txt-small-medium cursor-pointer border-b border-utility-blue-600 hover:text-utility-blue-700"
          >
            View transactions
            <Icons.ArrowUpRight className="size-4" />
          </div>
        </div>
      </div>
      <div className="grid grid-row-2 bg-bg-secondary rounded-xl m-2 mt-0 p-2xl">
        <div className="grid grid-cols-3 bg-bg-secondary rounded-xl m-2 mt-0 p-2xl">
          <div className="flex flex-col gap-md">
            <p className="txt-small-medium text-text-quaternary mb-xs">
              No. of transactions
            </p>
            <p className="txt-small-medium text-text-primary">
              {formatNumberWithCommas(numberOfTransactions)}
            </p>
          </div>

          <div className="flex flex-col gap-md">
            <p className="txt-small-medium text-text-quaternary mb-xs">
              Estimated gross sales
            </p>
            <p className="txt-small-medium text-text-primary">
              <span className="text-text-quaternary txt-small-medium mr-xxs">
                $
              </span>
              {formatNumberWithCommasAndDecimals(grossSales)}
            </p>
          </div>

          <div className="flex flex-col gap-md">
            <p className="txt-small-medium text-text-quaternary mb-xs">
              Estimated taxable sales
            </p>
            <p className="txt-small-medium text-text-primary">
              <span className="text-text-quaternary txt-small-medium mr-xxs">
                $
              </span>
              {formatNumberWithCommasAndDecimals(taxableSales)}
            </p>
          </div>
        </div>
        <div className="grid grid-cols-3 bg-bg-secondary rounded-xl m-2 mt-0 p-2xl">
          <div className="flex flex-col gap-md">
            <p className="txt-small-medium text-text-quaternary mb-xs">
              Estimated non-taxable sales
            </p>
            <p className="txt-small-medium text-text-primary">
              <span className="text-text-quaternary txt-small-medium mr-xxs">
                $
              </span>
              {formatNumberWithCommasAndDecimals(nonTaxableSales)}
            </p>
          </div>
          <div className="flex flex-col gap-md">
            <p className="txt-small-medium text-text-quaternary mb-xs">
              Estimated exempt sales
            </p>
            <p className="txt-small-medium text-text-primary">
              <span className="text-text-quaternary txt-small-medium mr-xxs">
                $
              </span>
              {formatNumberWithCommas(exemptSales)}
            </p>
          </div>

          <div className="flex flex-col gap-md">
            <p className="txt-small-medium text-text-quaternary mb-xs">
              Estimated marketplace sales
            </p>
            <p className="txt-small-medium text-text-primary">
              <span className="text-text-quaternary txt-small-medium mr-xxs">
                $
              </span>
              {formatNumberWithCommas(marketplaceSales)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
